<script>

import TokenTransactionsFilterPanel from "@/components/tokenTransactions/TokenTransactionsFilterPanel.vue";
import { useTokenTransactionDownloads } from "@/composables/useTokenTransactionDownloads.js";
import DownloadConfirmationsPanel from "@/components/tokenTransactions/DownloadConfirmationsPanel.vue";
import TokenTransactionsTable from "@/components/tokenTransactions/TokenTransactionsTable.vue";

export default {
    components: {TokenTransactionsTable, DownloadConfirmationsPanel, TokenTransactionsFilterPanel},
    setup() {
        const { download } = useTokenTransactionDownloads();

        return {
            download
        };
    },
    data() {
        return {
            error: '',
            loading: true,
            transactions: [],
            meta: {
                current_page: 1,
                total: 0,
                per_page: 0,
            },
            controller: null,
            filters: {},
            selectionMode: false,
            selectedIds: [],
            perPage: parseInt(localStorage.getItem('perPage_adminTransactions') || '10'),
        }
    },
    methods: {
        onChangeSelectionMode() {
            this.selectionMode = !this.selectionMode;
            if (!this.selectionMode) {
                this.selectedIds = [];
            }
        },
        onFiltersChange(filters) {
            this.filters = filters;
            this.meta.current_page = 1;
            this.loadData();
        },
        toggleRow(transaction) {
            const idx = this.selectedIds.indexOf(transaction.id);
            if (idx !== -1) {
                this.selectedIds.splice(idx, 1);
            } else {
                this.selectedIds.push(transaction.id);
            }
        },
        loadData() {
            this.controller = new AbortController();
            this.loading = true;
            window.scrollTo({top: 0});
            axios.get('/token-transactions/administration', {
                signal: this.controller.signal,
                params: {
                    page: this.meta.current_page,
                    per_page: this.perPage,
                    filters: this.filters
                }
            }).then(response => {
                this.transactions = response.data.data;
                this.meta.current_page = response.data.meta.current_page;
                this.meta.total = response.data.meta.total;
                this.meta.per_page = response.data.meta.per_page;
            }).finally(() => {
                this.loading = false;
            })
        },
        onPageChange(page) {
            this.controller.abort();
            this.meta.current_page = page;
            this.loadData();
        },
        onPerPageChange(val) {
            this.perPage = val;
            this.meta.current_page = 1;
            this.loadData();
        },
        download(transaction) {
            transaction.downloading = true;
            axios({
                url: '/token-transactions/' + transaction.id + '/confirmation',
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                saveAs(response.data, `potwierdzenie-transakcji-${transaction.id}.pdf`);
            }).finally(() => {
                transaction.downloading = false;
            });
        },
    },
    mounted() {
        this.loadData();
    },
    beforeUnmount() {
        this.controller.abort();
    }
}

</script>
<template>
    <section class="token-transfers-index">

        <div class="my-4">
            <TokenTransactionsFilterPanel @change="onFiltersChange" />
        </div>

        <DownloadConfirmationsPanel
            @onChangeSelectionMode="onChangeSelectionMode"
            :selectionMode="selectionMode"
            :administration-transactions="true"
            :filters="filters"
            :total="meta.total"
            :selectedIds="selectedIds"/>


        <TokenTransactionsTable
            :data="transactions"
            :meta="meta"
            :loading="loading"
            storage-key="perPage_adminTransactions"
            @onPageChange="onPageChange"
            @onPerPageChange="onPerPageChange"
        />

        <loader :loading="loading"/>

    </section>
</template>
